<viz-header title="NRP DASHBOARD" svgIcon="" [brandLink]="appURL">
  <viz-nav-menu icon="help">
    <viz-nav-menu-item title="Training Guides" link="https://www.vizientinc.com/my-dashboard/my-tools/nurse-residency-program#293938654" displayText="Training Guides"></viz-nav-menu-item>
  </viz-nav-menu>
  <viz-nav-menu icon="description" *ngIf="anyExportEnabled">
    <viz-nav-menu-item title="Export Dashboard" route="/reports-dashboard" displayText="Export Dashboard"></viz-nav-menu-item>
  </viz-nav-menu>
  <!-- <viz-nav-menu icon="notifications">
    <viz-nav-menu-item link="http://vizientinc.com" displayText="Test Link"></viz-nav-menu-item>
    <viz-nav-menu-item link="http://vizientinc.com" displayText="Test Link"></viz-nav-menu-item>
  </viz-nav-menu> -->
  <!-- <viz-nav-menu icon="apps">
    <viz-nav-menu-item route="/" displayText="Test Route With Really Long Text"></viz-nav-menu-item>
    <viz-nav-menu-item route="/" displayText="Test Route"></viz-nav-menu-item>
  </viz-nav-menu> -->
  <viz-nav-menu title="Surveys" [menuTitle]="SurveyMenuTitle" icon="arrow_drop_down" *ngIf="isAuthenticated" id="reportsMenu">
    <!-- <viz-nav-menu-item title="Termination Report" route="/loadreport/terminationreport" displayText="Termination Report"></viz-nav-menu-item>
    <viz-nav-menu-item title="Casey Fink Experience Report" route="/loadreport/CaseyFinkExperienceReport" displayText="Casey Fink Experience Report"></viz-nav-menu-item> -->
    <viz-nav-menu-item *ngFor="let report of reportLinks" [route]="getReportURL(report.tag)" [displayText]="report.displayName" [title]="report.displayName"></viz-nav-menu-item>
    <!-- <viz-nav-menu-item route="/notfound" displayText="error"></viz-nav-menu-item> -->
  </viz-nav-menu>
  <viz-nav-menu title="Benchmarks" menuTitle="Benchmarks" icon="arrow_drop_down" *ngIf="isAuthenticated" id="benchmarksMenu">
    <viz-nav-menu-item title="Manage Benchmarks" route="/comparegroups" displayText="Manage Benchmarks"></viz-nav-menu-item>
    <viz-nav-menu-item title="Manage Self Compare Benchmarks" route="/selfcomparegroups" displayText="Manage Self Compare Benchmarks"></viz-nav-menu-item>
  </viz-nav-menu>
  <!--<viz-nav-menu title="Help" icon="help">-->
  <!-- <viz-nav-menu title="Help" menuTitle="Help" icon="arrow_drop_down">
    <viz-nav-menu-item title="Training Guides" link="https://www.vizientinc.com/my-dashboard/my-tools/nurse-residency-program/nrp-online-tools" displayText="Training Guides"></viz-nav-menu-item>
  </viz-nav-menu> -->
  <viz-nav-menu icon="person"  *ngIf="isAuthenticated">
    <viz-nav-menu-item userName="{{loggedInUserName}}" [title]="loggedInUserName"></viz-nav-menu-item>
    <!-- <viz-nav-menu-item link="http://vizientinc.com" displayText="Test Link"></viz-nav-menu-item> -->
    <viz-nav-menu-item title="Logout" route="/logout" displayText="Logout"></viz-nav-menu-item>
  </viz-nav-menu>
</viz-header>
